import axios from 'axios';
import Settings from './config';

export default {
    getSystemBooking(id, cb) {
        axios.get(Settings.ENDPOINT + 'api/spa/' + id)
            .then(response => {
                cb(response.data);
            });
    },
    getConfiguration(cb) {
        axios.get('/umbraco/api/spa/getConfiguration')
            .then(response => {
                cb(response.data);
            });
    },

    getActivities(id,  cb) {
        axios.get(Settings.ENDPOINT + 'api/spa/activities/' + id)
            .then(response => {
                cb(response.data);
            });
    },

    getActivitiesList(payload, cb, fcb) {
        axios.get(Settings.ENDPOINT + 'api/spa/activities/' + payload.fromDate +'/' + payload.toDate)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                fcb(response);
            });
    },
    fetchGroupAvailability(payload, cb) {
        
        axios.post(Settings.ENDPOINT + 'api/spa/groups', payload)
            .then(response => {
                cb(response.data);
            });
    },


    getPackages(id, payload, cb) {
        axios.post(Settings.ENDPOINT + 'api/spa/packages', payload)
            .then(response => {
                cb(response.data);
            });
    },
    getFacilitiesAvailability(id, payload, cb) {

        axios.post(Settings.ENDPOINT + 'api/spa/facilities', payload)
            .then(response => {
                cb(response.data);
            });
    },
    buildItinerary(payload, cb, rej) {

        axios.post(Settings.ENDPOINT + 'api/spa/build-itinerary', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(reject => {
                rej(response)
            });

    },

    getAvailability(payload, cb) {

        axios.post(Settings.ENDPOINT + 'api/spa/search', payload)
            .then(response => {
                cb(response.data);
            });
    },


    getExtras(payload, cb) {

        axios.post(Settings.ENDPOINT + 'api/spa/extras', payload)
            .then(response => {
                cb(response.data);
            });
    },



    beginBooking(id, payload, cb, rej) {
        axios.post(Settings.ENDPOINT + 'api/spa/' + id + '/begin-booking', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                if (response != undefined) {
                    rej(response.data)
                }
            });

    },

    attachMonetaryVouchers(id, payload, cb, rej) {
        axios.post(Settings.ENDPOINT + 'api/spa/' + id + '/attach-vouchers', payload)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                if (response != undefined) {
                    rej(response.data)
                }
            });
    },


    processBooking(id, cb, rej) {
        axios.post(Settings.ENDPOINT + 'api/spa/' + id + '/process-booking')
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                if (response != undefined) {
                    rej(response.data)
                }
            });

    },
    fetchBookings(cb, rej) {

        axios.get(Settings.ENDPOINT + 'api/spa/user-bookings')
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                if (response != undefined) {
                    rej(response.data);
                }
            });
    },
    fetchBooking(id, cb, rej) {
        axios.get(Settings.ENDPOINT + 'api/spa/retrieve/' + id)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                if (response != undefined) {
                    rej(response.data);
                }
            });
    }, 
    sendEmail(payload, cb, fcb) {
        axios.post(Settings.ENDPOINT + 'api/spa/send-email/', payload)
            .then(response => {
                cb(response.data);
            }).catch(response => {
                fcb();
            });
    }
}